import { getKeys } from './getKeys'

export const logsTranslations = {
  NEXT: 'Next',
  NEW_LOG: 'New log',
  ADD_CUSTOM_ENTRY: 'Add a custom entry',
  LOG_UNAVAILABLE: "This log's questions couldn't be loaded. Please try again.",
  CHOOSE_A_RESIDENT: 'Choose a {{nominative}}',
  CHOOSE_A_CATEGORY: 'Choose a Category',
  CHOOSE_AN_ITEM: 'Choose an Item',
  SEARCH_BY_NAME: 'Search by name',
  SAVE_LOG: 'Save Log',
  SAVE_AND_KEEP_LOGGING: 'Save and Keep Logging',
  ADD_LOCATION: 'Add location',
  LOCATION_SELECTED: 'Location: {{location}}',
  LOCATIONS_TITLE: 'Add location',
  LOCATIONS_EMPTY_TITLE: 'Locations will appear here!',
  LOCATIONS_EMPTY_SUBTITLE: 'Add some in the incident report settings',
  SEIZURE_CONFIRM_TITLE: 'Are you sure?',
  SEIZURE_ESCALATION_MSG:
    'If you escalate this log by accident you will have to start again.\n\nAny goals will have to be re-done after escalation.',
  SEIZURE_DE_ESCALATION_MSG:
    'If you de-escalate this log by accident you will have to start again.\n\nAny goals will have to be re-done after de-escalation.',
  SEIZURE_NOTE:
    'Note: If an incident seizure log is under 3 mins consider logging as a health recording',
  SEIZURE_LOG_AS_INCIDENT: 'Log as an Incident',
  SEIZURE_LOG_AS_HEALTH_RECORDING: 'Log as a Health Recording',
  PERSPECTIVE_ALERT_TITLE:
    "Amazing! You've captured the voice of your {{value}}",
  PERSPECTIVE_ALERT_MSG:
    'This log will be modified to first person, reflecting the perspective of the person under your care.',
  PERSPECTIVE_ALERT_DONT_SHOW: 'Don’t show this again',
  PERSPECTIVE_ALERT_LEARN_MORE: 'Learn more',
  PERSPECTIVE_ALERT_OK: 'OK',
  DATE_LOGGED: 'Date logged',
  TIME_LOGGED: 'Time logged',
  LOG_VIEW_FLAGGED_FOR_HANDOVER: 'Flagged for handover',
  LOG_VIEW_LOG_ACTIVITY: 'Log activity',
  LOG_VIEW_LOGGED_BY: 'Logged by',
  LOG_VIEW_WITNESSED_BY: 'Witnessed by',
  LOG_VIEW_WITNESSED_BY_NAME: 'Witnessed by: {{name}}',
  WITNESS_APP_ONLY: 'Witnesses can only be added in the Carer App.',
  REMOVE_WITNESS: 'Remove {{name}} as witness',
  WITNESS_REMOVE_TITLE: 'Remove witness',
  WITNESS_REMOVE_MSG:
    "Witnesses can only be added in the Carer App, so you won't be able to add {{name}} back from the Care Office.",
  WITNESS_REMOVE_BTN: 'Remove witness',
  LOG_VIEW_LAST_EDITED: 'Last edited',
  LOG_VIEW_EDITED_BY: 'Edited by',
  LOG_VIEW_LOCATION: 'Location',
  LOG_VIEW_GPS_DISABLED: 'GPS disabled',
  LOG_VIEW_LEARN_ABOUT_GPS: 'Learn about GPS location',
  LOG_VIEW_LINKED_GOALS: 'Linked goals',
  LOG_VIEW_GPS_DISABLED_IMAGE: 'Map with no location available',
  LOG_VIEW_PHOTO_ALT: 'Log photo',
  SAVE_CHANGES: 'Save changes',
  LOG_UPDATED_TOAST: 'Updated the log',
  LOG_UPDATE_FAILED_TOAST: 'Failed to update the log',
  DELETE_LOG: 'Delete log',
  NO_QUESTIONNAIRE_NOTICE:
    "This log wasn't saved as a structured log, so you can edit its title, description and details below.",
  LOG_TITLE: 'Title',
  LOG_DESCRIPTION: 'Description',
  LOG_OUTCOME: 'Outcome',
  LOG_OUTCOME_ADMINISTERED: 'Administered',
  GOALS_LOAD_ERROR:
    "Linked goals couldn't be loaded. Any goals already linked are kept.",
  LOG_TITLE_REQUIRED: 'Add a title',
  LOG_MEASUREMENT_REQUIRED: 'Add a value',
  LEAVE_TITLE: 'Leave without saving?',
  LEAVE_MSG: 'Any changes you made to this log will be lost.',
  LEAVE: 'Leave',
  DELETE_LOG_TITLE: 'Delete log',
  DELETE_LOG_MSG:
    'Are you sure you want to delete this log? You can restore it from the log page.',
  LOG_DELETED_TOAST: 'Log removed',
  LOG_DELETE_FAILED_TOAST: 'Failed to delete the log',
  EDIT_UNAVAILABLE:
    "This log's questions couldn't be loaded, so it can't be edited here.",
  SKIPPED: 'Skipped',
  ADD_A_NEW: 'Add a new {{name}}',
  GROUP_ROW_TITLE: '{{type}} {{number}}',
  LABEL_WITH_COLON: '{{label}}:',
  REMOVE_ROW: 'Remove {{title}}',
  TIME: 'Time',
  FLAG_FOR_HANDOVER: 'Flag for handover',
  UNFLAG_FOR_HANDOVER_TITLE: 'Please confirm Un-Flag.',
  UNFLAG_FOR_HANDOVER_MSG:
    'If you un-flag this log it will not appear in the handover report.',
  UNFLAG: 'Un-Flag',
  HANDOVER_LOCKED_NOTE: 'After 48 hours, logs cannot be flagged for handover.',
  CHANGE_LOG_PERSPECTIVE: 'Change log perspective',
  COMPLETED_BY_HIMSELF: 'This log has been completed by {{name}} himself',
  COMPLETED_BY_HERSELF: 'This log has been completed by {{name}} herself',
  COMPLETED_BY_THEMSELF: 'This log has been completed by {{name}} themself',
  ADD_MEDIA: 'Add Media',
  MEDIA_REMOVE_TITLE: 'Remove Media',
  MEDIA_REMOVE_PHOTO_MSG: 'Are you sure you want to remove this photo?',
  MEDIA_REMOVE_VIDEO_MSG: 'Are you sure you want to remove this video?',
  MEDIA_REMOVE_PHOTO_BTN: 'Remove Photo',
  MEDIA_REMOVE_VIDEO_BTN: 'Remove Video',
  MEDIA_LIMIT_TITLE: 'Upload limit reached',
  MEDIA_LIMIT_MSG: 'You reached the maximum number of media you can upload.',
  MEDIA_UPLOAD_ERROR: "We couldn't save your media. Please try again.",
  ADD_MORE_MEDIA: 'Add more media',
  LINK_A_GOAL: 'Link a goal',
  LINKING_GOALS_TITLE: 'Linking goals',
  NO_GOALS_TO_LINK: 'No goals to link',
  REMOVE_GOAL: 'Remove {{title}}',
  BACK: 'Back',
  MINUTES: 'Minutes',
  SECONDS: 'Seconds',
  DURATION_SECONDS_TOO_HIGH:
    'Please enter 59 seconds or fewer, and add any extra time to the minutes.',
  QUESTIONS_LOAD_ERROR: 'Error loading the questions for this log',
  LOG_ADDED_TOAST: 'Added a Log',
  LOG_ADD_FAILED_TOAST: 'Failed to add the log',
  MEDIA_UNSUPPORTED_FORMAT_TITLE: 'Photo format not supported',
  MEDIA_UNSUPPORTED_FORMAT_MSG:
    'This photo is in a format we can’t upload (e.g. RAW). Please choose a different photo.',
  VIDEO_UNSUPPORTED_FORMAT_TITLE: 'Video format not supported',
  VIDEO_UNSUPPORTED_FORMAT_MSG:
    'This video is in a format we can’t upload. Please choose an MP4, MOV or WebM video.',
  MEDIA_NOT_ALLOWED_TITLE: 'Media not allowed',
  MEDIA_NOT_ALLOWED_MSG:
    'Your home’s settings don’t allow this type of media on logs.',
  VIDEO_TOO_LONG_TITLE: 'Video limit exceeded',
  VIDEO_TOO_LONG_MSG:
    'This video is too large! Please select a clip of {{value}} seconds or under.',
  LOG_DUPLICATE_TOAST:
    "This log is a duplicate and can't be saved. Please try again after a short while."
}

export const logsConstants = getKeys(logsTranslations)
